export class AuditLogEntity {
    Code: string;
    Name: string;
}